import styled from 'styled-components'

const flex = 'display: flex; align-items: center; justify-content: space-between;'

export const StyledHeader = styled.div`
  ${flex}

  & > button {
    padding: 0;
    background-color: transparent;
  }

  @media screen and (max-width: ${props => props.theme.screens.tablet}) {
    div[role='options'] {
      left: unset;
      right: 0;
    }
  }
`

export const Logo = styled.img`
  width: auto;
  height: 1.25rem;
`

export const MobileMenuHandler = styled.div`
  @media screen and (min-width: ${props => props.theme.screens.tablet}) {
    display: none;
  }
`

export const RightSection = styled.div<{ publicPage?: boolean }>`
  ${flex};

  & > div:first-child {
    margin-right: ${props => props.theme.spacing.default};
  }

  @media screen and (max-width: ${props => props.theme.screens.tablet}) {
    display: ${props => (props.publicPage ? 'flex' : 'none')};
  }
`

export const HeaderItemWrapper = styled.div`
  & > div:first-of-type {
    div[role='options'] {
      width: unset;
      box-shadow: 0px 12px 40px rgba(24, 19, 74, 0.12);
      & > button {
        background-color: ${props => props.theme.colors.white[500]};
        //check
        padding: ${props => props.theme.spacing.large};
        border-radius: ${props => props.theme.radius.medium};
        height: unset;
        & > div {
          display: flex;
          align-items: center;
          gap: ${props => props.theme.spacing.default};
          border-radius: ${props => props.theme.radius.medium};
          //check
          padding: ${props => props.theme.spacing.medium};
          white-space: nowrap;
        }

        &:hover {
          background-color: ${props => props.theme.colors.white[500]};
          & > div {
            background-color: ${props => props.theme.colors.white[300]};
          }
        }
      }
    }
    & > div:first-of-type {
      border: none;
      white-space: nowrap;
      & > div:first-of-type {
        margin-right: 0;
      }
      & > div:last-of-type {
        svg {
          display: none;
        }
      }
    }
  }

  svg {
    color: ${props => props.theme.colors.secondary[500]};
  }
`
